import React, { useEffect, useState } from 'react'
import Field, {DjangoField} from 'championship/src/components/Fields/Field'
import { useAtom, useCtx } from '@reatom/npm-react'
import { 
    getModelAtom,
    changeTabAction,
    getModelSchema,
    getModel,
    // checkTabValidation
} from '../../model'

import { AnimatePresence } from 'motion/react'

import {checkTabValidation, usePreventValidation} from '../utils'
import { atom } from '@reatom/core'
// import { useConditionalModelAtom, installTabValidation, getConditionalModelAtom } from '../utils'


function TabFormat({ model }){
    
    const {prevent_validation} = usePreventValidation()

    const ctx = useCtx()
    const tab_model = getModel(model)
    const tab = tab_model.schema
    const [tab_state, setTabState] = useAtom(tab_model.atom)

    const validation = tab_model.schema.validation
    const [atoms, unsubscribes, validate] = validation   

    const [qualifying_stage,] = useAtom(getModelAtom('tournament.qualifying_stage'))

    const [has__max_series,] = useAtom(atoms['settings.max_series'])
    const [has__sector,] = useAtom(atoms['settings.target_sector'])
    const [has__group_count,] = useAtom(atoms['tournament.group_count'])
    const [has__round_count,] = useAtom(atoms['tournament.round_count'])

    // const [is__double, setDouble] = useAtom(atoms('tournament.double_selection'))
    // const [is__online, setOnline] = useAtom(atoms('settings.split_input'))

    const [is__double,] = useAtom(getModelAtom('tournament.double_selection'))

    // const [is__online, setOnline] = useAtom(getModelAtom('settings.split_input'))
    const [has__darts_target_count,] = useAtom(atoms['tournament.darts_target_count'])
    const [has__qualifying_grid_third_place,] = useAtom(atoms['tournament.qualifying_grid_third_place'])

    const [has__final_grid_third_place,] = useAtom(atoms['tournament.final_grid_third_place'])
    const [has__participant_count_to_advance_per_qualifying,] = useAtom(atoms['tournament.participant_count_to_advance_per_qualifying'])
    // const [is__double, setDouble] = useAtom(getModelAtom('tournament.double_selection'))
    // const [is__online, setOnline] = useAtom(getModelAtom('settings.split_input'))

    const build_atom_qualifying_stage = atom((ctx) => {
        const computed = ctx.spy(getModelAtom('tournament.double_selection'))
        if(!computed){
            return [
                {value:'', label: '—'},
                {value:'grid', label: 'Олимпийская сетка'},
                {value:'group', label:'Групповая система'},
                {value:'round', label:'Круговая система'},
            ]
        }else{
            return [
                {value:'', label: '—'},
                {value:'group', label:'Групповая система'},
                {value:'round', label:'Круговая система'},
            ]
        }
    })    
    
    return (
        <AnimatePresence>
        <div className="reactive-form-tab-body" ref={tab.ref_body}>
            <div className="reactive-form-tab-body__inner">
                <div className="f-row">
                    <div className="f-col f-col-lg-3 f-col-12">
                        <div className="page-heading -underline">
                            Формат турнира
                        </div>
                    </div>
                    <div className="f-col f-col-lg-9 f-col-12">
                        <div className="f-row f-g-4 f-gy-lg-5">
                            <div className="f-col f-col-12">
                                <div className="f-row f-g-4 f-gy-lg-5">
                                    <div className="f-col f-col-lg-4 f-col-12">
                                        <DjangoField
                                            model='format:tournament.type_game'
                                            label="Дисциплина"
                                            ctx={ctx}
                                            />
                                    </div>
                                    <div className="f-col f-col-lg-4 f-col-12">
                                        <DjangoField 
                                            model="settings.split_input"
                                            label="Формат проведения"
                                            ctx={ctx}
                                            />
                                    </div>
                                    {has__darts_target_count && (
                                        <div className="f-col f-col-lg-4 f-col-12">
                                                <DjangoField
                                                    model='tournament.darts_target_count'
                                                    ctx={ctx}
                                                    label="Количество мишеней"
                                                    />
                                        </div>
                                    )}
                                    {/* <div className="f-col f-col-lg-4 f-col-12">
                                        <DjangoField
                                            ctx={ctx}
                                            model="tournament.duration_game"
                                            label="Длительность игры"
                                            />
                                    </div> */}
                                    {has__max_series && (
                                        <div className="f-col f-col-lg-4 f-col-12">
                                            <DjangoField
                                                model='settings.max_series'
                                                ctx={ctx}
                                                label="Количество подходов в леге"
                                                />
                                        </div>
                                    )}
                                    {has__sector && (
                                        <div className="f-col f-col-lg-4 f-col-12">
                                            <DjangoField
                                                model='settings.target_sector'
                                                ctx={ctx}
                                                label="Сектор"
                                                />
                                        </div>
                                    )}
                                    <div className="f-col f-col-12">
                                        <div className="reactive-form-flex-row">

                                            <DjangoField
                                                type="switch"
                                                model="tournament.double_selection"
                                                ctx={ctx}
                                                label="Двухступенчатый"
                                                required={false}
                                                />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="f-col f-col-12">
                                <div className="f-row f-g-4 f-gy-lg-5">
                                    <div className="f-col f-col-lg-4 f-col-12">
                                        <DjangoField
                                            model="tournament.qualifying_stage"
                                            ctx={ctx}
                                            build_atom={build_atom_qualifying_stage}
                                            label={`Стадия ${is__double ? '1' : ''}`}
                                            />
                                    </div>

                                    {(has__group_count || has__round_count) && (
                                        <div className="f-col f-col-lg-3 f-col-12">
                                            {has__group_count && (
                                                <DjangoField 
                                                    model="tournament.group_count"
                                                    ctx={ctx}
                                                    label='Количество групп'
                                                    />
                                            )}

                                            {has__round_count && (
                                                <DjangoField 
                                                    model="tournament.round_count"
                                                    ctx={ctx}
                                                    label='Количество кругов'
                                                    />
                                            )}
                                        </div>
                                    )}
                                    {has__participant_count_to_advance_per_qualifying && (
                                        <div className="f-col f-col-lg-5 f-col-12">
                                            <DjangoField 
                                                model="tournament.participant_count_to_advance_per_qualifying"
                                                ctx={ctx}
                                                label="Кол-во выходящих из каждой группы"
                                                />
                                        </div>
                                    )}
                                </div>
                            </div>
                            {
                                (is__double 
                                    || has__final_grid_third_place
                                    || has__qualifying_grid_third_place 
                                )
                                && (
                                    <div className="f-col f-col-12">
                                        <div className="f-col-separator"></div>
                                        {/* {(is__double || has__qualifying_grid_third_place) && ( */}
                                    
                                        <div className="f-row f-g-4 f-gy-lg-5">
                                            {is__double && (
                                                <div className="f-col f-col-lg-4 f-col-12">
                                                        <DjangoField
                                                            // model="tournament.qualifying_stage_2"
                                                            model="tournament.final_stage"
                                                            ctx={ctx}
                                                            label="Стадия 2"
                                                            />
                                                </div>
                                            )}
                                            {is__double && (
                                                <div className="f-col f-col-lg-4 f-col-12">
                                                        <DjangoField 
                                                            model="tournament.grid_qualification_rules"
                                                            ctx={ctx}
                                                            label="Правила выхода в сетку"
                                                            />
                                                </div>
                                            )}
                                            <div className="f-col f-col-12">
                                                <div className="reactive-form-flex-row">
                                                    {has__final_grid_third_place && (
                                                        <DjangoField 
                                                            model="tournament.final_grid_third_place"
                                                            ctx={ctx}
                                                            label="Игра за 3 место"
                                                            />
                                                    )}
                                                    {has__final_grid_third_place && (
                                                        <DjangoField 
                                                            model="tournament.final_grid_outside"
                                                            ctx={ctx}
                                                            label="Нижняя сетка"
                                                            />
                                                    )}
                                                    {has__qualifying_grid_third_place && (
                                                        <DjangoField 
                                                            model="tournament.qualifying_grid_third_place"
                                                            ctx={ctx}
                                                            label="Игра за 3 место"
                                                            />
                                                    )}
                                                    {has__qualifying_grid_third_place && (
                                                        <DjangoField 
                                                            model="tournament.qualifying_grid_outside"
                                                            ctx={ctx}
                                                            label="Нижняя сетка"
                                                            />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="reactive-form-buttons">
                <button className="button" onClick={() => {changeTabAction(ctx, -1)}}>
                    Назад
                </button>
                <button
                    className="button -fill"
                    disabled={!tab_state.is_done}
                    onClick={() => {
                        if(tab_state.is_done){
                            changeTabAction(ctx, 1)
                        } 
                    }}
                    onMouseEnter={()=> {
                        if(!prevent_validation){
                            checkTabValidation(ctx, tab_model)
                        }
                    }}
                    >
                    Далее
                </button>
                {/* <div className="button" onClick={() => {checkTabValidation(ctx, tab_model)}}>
                    ?
                </div> */}
            </div>
        </div>
        </AnimatePresence>
    )
}

export default TabFormat